import { getAccessToken, getSubId } from '@devhacker/shared/features/auth/utils/token';

const routesNeedCheck = [
  'profile-edit',
  'profile-settings',
  'profile-favorites',
  'profile-notifications',
];

export default defineNuxtPlugin(() => {
  const route = useRoute();
  if (!route.name || !routesNeedCheck.includes(route.name as string)) return;

  const token = getAccessToken();
  if (!token) return;

  const subId = getSubId(token);
  if (!subId) return;

  if (String(route.params.userId) !== String(subId)) {
    location.href = '/';
  }
});
